/**
 * Authenticated chat dictation — server-side STT (Deepgram/etc).
 * Never returns provider grant JWTs to the browser.
 */

import { request } from './core'

export interface ChatDictationStatus {
  available: boolean
  provider?: string | null
  model_id?: string | null
  display_name?: string | null
}

export interface ChatDictationResult {
  text: string
  confidence?: number | null
  language?: string | null
  provider?: string | null
  model_id?: string | null
  latency_ms: number
}

function filenameForAudioBlob(blob: Blob): string {
  const mime = blob.type || ''
  if (mime.includes('webm')) return 'recording.webm'
  if (mime.includes('m4a')) return 'recording.m4a'
  if (mime.includes('mp4')) return 'recording.mp4'
  if (mime.includes('mpeg') || mime.includes('mp3')) return 'recording.mp3'
  if (mime.includes('ogg')) return 'recording.ogg'
  if (mime.includes('wav')) return 'recording.wav'
  if (mime.includes('flac')) return 'recording.flac'
  return 'recording.webm'
}

export const chatDictationApi = {
  getStatus(): Promise<ChatDictationStatus> {
    return request<ChatDictationStatus>('/v1/chat/dictation/status')
  },

  transcribe(audioBlob: Blob): Promise<ChatDictationResult> {
    const formData = new FormData()
    formData.append('file', audioBlob, filenameForAudioBlob(audioBlob))
    return request<ChatDictationResult>('/v1/chat/dictation/transcribe', {
      method: 'POST',
      body: formData,
      headers: {},
    })
  },
}
